module.exports = __webpack_public_path__ + "img/6.5b276ab6.jpg";